export const FETCH_SHOP = 'app/shopDetails/FETCH_SHOP';

export const FETCH_EXTENDED_MENU = 'app/shopDetails/FETCH_EXTENDED_MENU';

export const FETCH_SHELVES_MENU = 'app/shopDetails/FETCH_SHELVES_MENU';

export const FETCH_SHELVES_MENU_ITEMS =
  'app/shopDetails/FETCH_SHELVES_MENU_ITEMS';

export const CLOSE_NO_LOCATION_POINT_TOAST =
  'app/shopDetails/CLOSE_NO_LOCATION_POINT_TOAST';

export const CLOSE_MAX_PRODUCT_QUANTITY_TOOLTIP =
  'app/shopDetails/CLOSE_MAX_PRODUCT_QUANTITY_TOOLTIP';

export const FETCH_MEASUREMENT_UNITS_LIST =
  'app/shopDetails/FETCH_MEASUREMENT_UNITS_LIST';

export const CLOSE_ONLINE_PAYMENT_TOOLTIP =
  'app/shopDetails/CLOSE_ONLINE_PAYMENT_TOOLTIP';

export const FETCH_SECTIONS_LIST = 'app/shopDetails/FETCH_SECTIONS_LIST';

export const GROCERIES_TAB_CHANGED = 'app/shopDetails/GROCERIES_TAB_CHANGED';

export const EXTENDED_MENU_SECTION_CHANGED =
  'app/shopDetails/EXTENDED_MENU_SECTION_CHANGED';

export const SECTION_HEIGHT_UPDATED = 'app/shopDetails/SECTION_HEIGHT_UPDATED';

export const FETCH_CAPACITY_CHECK = 'app/shopDetails/FETCH_CAPACITY_CHECK';

export const ONE_CLICK_PRODUCT_SELECTED =
  'app/shopDetails/ONE_CLICK_PRODUCT_SELECTED';

export const FETCH_ALL_SECTIONS = 'app/shopDetails/FETCH_ALL_SECTIONS';

export const SECTIONS_TAB_CHANGED = 'app/shopDetails/SECTIONS_TAB_CHANGED';

export const FETCH_DISTANCE_VENDOR_PICKUP =
  'app/shopDetails/FETCH_DISTANCE_VENDOR_PICKUP';

export const FETCH_PREFERRED_DISHES = 'app/shopDetails/FETCH_PREFERRED_DISHES';
